export default {
  "menu.login": "ログイン",
  "menu.overview": "俯瞰",
  "menu.calendar": "カレンダー",
  "menu.projects": "プロジェクト",
  "menu.quality": "品質管理",
  "menu.resources": "リソース",
  "menu.mindmaps": "マインドマップ",
  "menu.customers": "顧客 / 製品",
  "menu.holidays": "祝日",
  "menu.notifications": "通知",
  "menu.settings": "設定",
  "menu.account.logout": "ログアウト",
};
